import { Text } from "react-native";
import { os } from "../platform";
import { fontFamilyStyle } from "../utils/styles/typography";

const SEOHeaderTags = ({ style, text, tag = "h2" }) => {
  const Tag = tag;
  const styles =
    os === "web"
      ? {
          ...style,
          ...fontFamilyStyle,
        }
      : style;

  return os === "web" ? (
    <Tag style={styles}>{text}</Tag>
  ) : (
    <Text
      style={styles}
      accessible={true}
      accessibilityRole="header"
      accessibilityLabel={text}
      maxFontSizeMultiplier={1.2}
    >
      {text}
    </Text>
  );
};

export default SEOHeaderTags;
